import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useStoreLoader } from "./loader";
import { useStoreSnackbar } from "./snackbar";
const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
export const useStoreLogin = create(
  persist(
    (set) => ({
      // user: null,
      // authToken: null,
      // setUser: (user) => set({ user }),
      user: null,
      authToken: null,
      // ... other state
      updateUser: (userData) => set({ user: userData }),

      login: async (userData) => {
        const { username, password } = userData;

        if (!username || !password) {
          useStoreSnackbar.getState().showSnackbar({
            description: "Username & Password are required",
            title: "Required",
            color: "danger",
          });
          return;
        }
        useStoreLoader.getState().setLoading(true);

        try {
          let response = await fetch(`${baseUrl}/api/auth/signin`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
          });
          if (!response.ok) {
            useStoreSnackbar.getState().showSnackbar({
              description: "Invalid Username or password",
              title: "Invalid",
              color: "danger",
            });
            response = await response.json();
            return;
          } else {
            response = await response.json();
            set({ user: response.user, authToken: response.token });
            useStoreSnackbar.getState().showSnackbar({
              description: "You have successfully Logged In",
              title: "Successfully login",
              color: "success",
            });
          }
        } catch (error) {
          useStoreSnackbar.getState().showSnackbar({
            description: "Error in Login",
            title: error,
            color: "danger",
          });
        } finally {
          useStoreLoader.getState().setLoading(false);
        }
      },
      getLoginOtp: async (userData) => {
        return new Promise(async (resolve, reject) => {
          if (!userData.username) {
            useStoreSnackbar
              .getState()
              .showSnackbar({
                description: "Mobile is required",
                title: "Invalid Input",
                color: "error",
              });
            return;
          }
          const regex = /^(?:\+91|91)?[6-9]\d{9}$/;
          if (!regex.test(userData.username)) {
            useStoreSnackbar
              .getState()
              .showSnackbar({
                description: "Enter Valid Mobile Number",
                title: "Invalid Input",
                color: "error",
              });
          }
          useStoreLoader.getState().setLoading(true);

          let response;
          try {
            response = await fetch(`${baseUrl}/api/public/send-otp`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(userData),
            });
            if (!response.ok) {
              response = await response.json();
              throw new Error(response.message);
            } else {
              response = await response.json();
              resolve(response);
            }
          } catch (error) {
            useStoreSnackbar
              .getState()
              .showSnackbar({
                description: error.message,
                title: "Error",
                color: "error",
              });

            reject(error?.message || "Error Occured");
            console.log(error);
          } finally {
            useStoreLoader.getState().setLoading(false);
          }
        });
      },
      verifyLoginOtp: async (userData) => {
        if (!userData.otp) {
          useStoreSnackbar
            .getState()
            .showSnackbar({
              description: "Otp is required",
              title: "Invalid Input",
              color: "error",
            });
          return;
        }
        if (!userData.id) {
          useStoreSnackbar
            .getState()
            .showSnackbar({
              description: "Otp id is required",
              title: "Invalid Input",
              color: "error",
            });
          return;
        }
        if (!userData.mobile) {
          useStoreSnackbar
            .getState()
            .showSnackbar({
              description: "mobile is required",
              title: "Invalid Input",
              color: "error",
            });
          return;
        }
        if (!userData.user) {
          useStoreSnackbar
            .getState()
            .showSnackbar({
              description: "user is required",
              title: "Invalid Input",
              color: "error",
            });
          return;
        }
        useStoreLoader.getState().setLoading(true);
        let response;
        try {
          response = await fetch(`${baseUrl}/api/public/varify`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
          });
          if (!response.ok) {
            response = await response.json();
            // throw new Error(response.message);
            useStoreSnackbar.getState().showSnackbar({
              description: response.message || "OTP verification failed. Please try again.",
              title: response.code || "Invalid OTP",
              color: "error",
            });

            return;
          } else {
            response = await response.json();
            set({ user: response.user, authToken: response.token });
            useStoreSnackbar.getState().showSnackbar({
              description: "You have successfully Logged In",
              title: "Successfully login",
              color: "success",
            });
          }
        } catch (error) {
          useStoreSnackbar
            .getState()
            .showSnackbar({
              description: error.message,
              title: "Error",
              color: "error",
            });
          console.log(error);
        } finally {
          useStoreLoader.getState().setLoading(false);
        }
      },
      logout: () => set({ user: null, authToken: null }),
    }),
    {
      name: "bears-storage",
    }
  )
);
